<template>
    <div>
        <div v-if="message.msg != ''">
            <Message :message="message" />
        </div>
        <div v-if="total_count > 0" class="component-data">
            <b-container fluid>
                <b-row v-if="!isLoading && total_count > 20" >
                    <b-col md="8" class="my-1">
                        <b-form-group label-cols-sm="3" label="Filtro" class="mb-0">
                        <b-input-group>
                            <b-form-input v-model="filter" placeholder="Buscar"></b-form-input>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col md="4" class="my-2">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="total_count"
                            :per-page="perPage"
                            aria-controls="dataTable"
                        ></b-pagination>
                    </b-col>
                </b-row>

                <b-table hover responsive
                    :items="componentData" 
                    id="dataTable"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :fields="fields"
                    :filter="filter"
                    :busy="isLoading"
                    @filtered="onFiltered"
                >
                    <template slot="rfc" slot-scope="row">
                        {{ row.value }}
                    </template>
                    <template slot="name" slot-scope="row">
                        {{ row.value }}
                    </template>
                    <template slot="status" slot-scope="row">
                        {{ row.value }}
                    </template>
                </b-table>
            </b-container>
        </div>
    </div>
</template>

<script>
import Message from './Message';

export default {
    name: 'Result',
    props: {
        records: Array
    },
    components: {
        Message
    },
    data() {
        return {
            componentData: [],
            isLoading: false,
            perPage: 20,
            currentPage: 1,
            totalRows: 0,
            filter: null,
            total_count: 0,
            message: {},
            fields: {
                id: {
                    label: '#',
                    sortable: true,
                    tdClass: 'align-middle'
                },
                rfc: {
                    label: 'R.F.C.',
                    sortable: true,
                    tdClass: 'align-middle'
                },
                name: {
                    label: 'RAZÓN SOCIAL',
                    tdClass: 'align-middle'
                },
                situation: {
                    label: 'SITUACIÓN',
                    sortable: true,
                    tdClass: 'align-middle'
                }
            }
        }
    },
    filters: {
        capitalize: function(str) {
            return str.toUpperCase();
        }
    },
    methods: {
        onFiltered: function(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
    },
    mounted: function() {
        var vm = this;
        this.$watch('records', items => {
            vm.isLoading = true;
            vm.message = {
                msg: '',
                variant: 'info',
                dismiss: 5
            }
            vm.componentData = [];
            vm.total_count = items[0].length;
            for (var i=0; i < vm.total_count; i++) {
                var item = items[0][i];
                var record = {
                    id: (i + 1),
                    rfc: item.rfc,
                    name: item.data.name,
                    situation: item.data.situation
                };
                if (record.situation === 'Presunto'){
                    record['_rowVariant'] = 'warning';
                } else if (record.situation === 'Definitivo'){
                    record['_rowVariant'] = 'danger';
                } else if (record.situation === 'Sentencia Favorable'){
                    record['_rowVariant'] = 'success';
                } 
                vm.componentData.push(record);    
            }
            vm.isLoading = false;
            vm.message.msg = "Fueron encontrados " + vm.total_count + " registros";
        }, {immediate:true});
    }
};
</script>


<style>
.h-center {
    text-align: center;
}
.btn.btn-sm {
    padding: .5rem 1.6rem;
    font-size: .64rem;
}
button, html [type=button] {
    -webkit-appearance: none;
}
.btn-rounded {
    -webkit-border-radius: 10em;
    border-radius: 10em;
}
.btn-danger {
    background-color: #ff3547!important;
    color: #fff;
}
.btn {
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12);
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    margin: .375rem;
    border: 0;
    text-transform: uppercase;
    white-space: normal;
    word-wrap: break-word;
}
</style>